(function ($) {
  Drupal.behaviors.contentFilterSetFormatterV2 = {
    attached: false,
    draggingInProgress: false,
    isMobileLayout: false,
    queryParams: {
      filter: 'All',
      sort: false,
      secondaryFilterSelector: false,
      currentPage: 1,
    },
    lastSort: false,
    results: {
      resultsPerPage: 8,
      $allFilteredElements: false,
      $renderedResults: false,
      resultsArray: [],
    },
    allSecondaryFilters: [],
    nodes: {},
    selectors: {
      html: 'html',
      body: 'body',
      gnavHeader: '.js-site-header-formatter__header',
      siteHeaderSticky: '.js-site-header-sticky',
      modules: '.js-content-filter-set-formatter-v2',
      unwrapNodeRefs: '.js-content-formatter-rendered > .block-nodeblock, .js-content-formatter-rendered > div > .block-nodeblock',
      elements: '.js-content-filter-tout',
      tipElements: '.js-content-filter-tout--tip',
      controlsContainer: '.js-content-filter-set-formatter-controls',
      filters: '.js-content-filters',
      primaryFiltersContainer: '.js-content-filters, .js-content-filter-set-filters-primary',
      primaryFilterBtn: '.js-content-filter-set-filter-button',
      secondaryFiltersContainer: '.js-content-filter-set',
      filterClear: '.js-filter-clear',
      filterMore: '.js-content-filter-more',
      filterNoResults: '.js-content-filter-no-results',
      filterGrid: '.js-content-filter-grid',
      sortSelect: '.js-content-sort-menu',
      sortDropdownMenu: '.js-content-sort-menu-selectBox-dropdown-menu',
      contentFormatter: '.js-content-formatter-rendered',
      contentCountContainer: '.js-content-filter-set-formatter-controls--count',
      contentCountNumber: '.js-content-count-number',
      contentCountSingularSuffix: '.js-content-count-singular-suffix',
      contentCountPluralSuffix: '.js-content-count-plural-suffix',
      contentFilterTitleLabel: '.js-content-filter-set-formatter-title-label',
      emptyElements: '.js-empty-grid-item',
    },
    attach: function (context) {
      var self = this;
      var $modules = $(self.selectors.modules, context);

      if (self.attached) {
        return;
      }

      $modules.each(function () {
        var $module = $(this);
        self.setup($module);
      });

      self.attached = true;
    },
    setup: function ($module) {
      var self = this;
      var $unwrapNodeRefs = $(self.selectors.unwrapNodeRefs, $module);

      $unwrapNodeRefs.each(function () {
        var $nodeBlock = $(this);
        var $rendered = $nodeBlock.closest(self.selectors.contentFormatter);
        var $touts = $(self.selectors.elements, $nodeBlock);

        $touts.each(function () {
          var $tout = $(this);
          $tout.wrap('<div class="content-formatter__rendered result-hidden" role="listitem"></div>');
          $tout.parent().insertBefore($rendered);
        });
        $rendered.remove();
      });
      
      self.getDom($module);
      self.init($module);
      self.setEvents($module);

      $(document).trigger('contentFilter.initSecondaryFilters', [self.allSecondaryFilters, self.attached]);
    },
    getDom: function ($module) {
      var self = this;

      $module.nodes = {};
      $module.nodes.$html = $(self.selectors.html);
      $module.nodes.$body = $(self.selectors.body);
      $module.nodes.$elements = $(self.selectors.elements, $module);
      $module.nodes.$controlsContainer = $(self.selectors.controlsContainer, $module);
      $module.nodes.$filters = $(self.selectors.filters, $module);
      $module.nodes.$primaryFilterBtn = $(self.selectors.primaryFilterBtn, $module.nodes.$filters);
      $module.nodes.$secondaryFiltersContainer = $(self.selectors.secondaryFiltersContainer, $module);
      $module.nodes.$filterClear = $(self.selectors.filterClear, $module);
      $module.nodes.$filterMore = $(self.selectors.filterMore, $module);
      $module.nodes.$filterNoResults = $(self.selectors.filterNoResults, $module);
      $module.nodes.$filterGrid = $(self.selectors.filterGrid, $module);
      $module.nodes.$sortSelect = $(self.selectors.sortSelect, $module);
      $module.nodes.$contentFormatter = $(self.selectors.contentFormatter, $module);
      $module.nodes.$contentCountContainer = $(self.selectors.contentCountContainer, $module);
      $module.nodes.$contentCountNumber = $(self.selectors.contentCountNumber, $module.nodes.$contentCountContainer);
      $module.nodes.$contentCountSingularSuffix = $(self.selectors.contentCountSingularSuffix, $module.nodes.$contentCountContainer);
      $module.nodes.$contentCountPluralSuffix = $(self.selectors.contentCountPluralSuffix, $module.nodes.$contentCountContainer);
      $module.nodes.$contentFilterTitleLabel = $(self.selectors.contentFilterTitleLabel, $module);
    },
    init: function ($module) {
      var self = this;

      self.queryParams.filter = $module.nodes.$filterClear.text() && $module.nodes.$filterClear.text().trim();
      self.isMobileLayout = Unison.fetch.now().name === 'small';
      $module.nodes.$sortSelect.selectBox({ mobile: true, loopOptions: true });
      self.queryParams.sort = $module.nodes.$sortSelect.val();
      self.results.resultsPerPage = $module.data('results-count') && parseInt($module.data('results-count')) > 0 ? parseInt($module.data('results-count')) : self.results.resultsPerPage;

      // Add CSS class for setup
      $module.nodes.$elements.filter(self.selectors.tipElements).parent().addClass('js-result-full result-full');
      $module.nodes.$elements.addClass('js-filter--' + self.sanitizedFilter(self.queryParams.filter).toLowerCase());
      $module.nodes.$elements.each(function () {
        var $elem = $(this);
        var setIndex = 0;
        var allFilters = $elem.data('filters');
        var secondaryFilters = $elem.data('secondary-filters');

        if (allFilters) {
          allFilters.split(',').forEach(function (filter) {
            $elem.addClass('js-filter--' + self.sanitizedFilter(filter).toLowerCase());
          });
        }
        /*
        * Secondary Filters
        * There are multiple secondary filter sets, delimited by "|".
        * Each set can contain multiple filters separated by * ",".
        */
        if (secondaryFilters) {
          secondaryFilters.split('|').forEach(function (secondaryFilterSet) {
            if (!self.allSecondaryFilters[setIndex]) {
              self.allSecondaryFilters[setIndex] = [];
            }
            secondaryFilterSet.split(',').forEach(function (filter) {
              var trimmedFilter = filter.trim();
              var selector = 'js-secondary-filter-' + setIndex + '--' + self.sanitizedFilter(filter).toLowerCase();

              if (trimmedFilter.length > 0) {
                self.allSecondaryFilters[setIndex][trimmedFilter] = selector;
                $elem.addClass(selector);
              }
            });
            setIndex++;
          });
        }
      });

      // If this page is being loaded with preset parameters
      if (self.getURLParameter('section')) {
        self.parseAndRenderURL($module);
      } else {
        self.updateURL($module);
      }
    },
    setEvents: function ($module) {
      var self = this;

      Unison.on('change', function () {
        self.isMobileLayout = Unison.fetch.now().name === 'small';
      });

      $(window).on(
        'scroll',
        _.debounce(function () {
          self.stickyControls($module);
        }, 10)
      ).on(
        'resize',
        _.debounce(function () {
          self.toggleColumnChangeClasses($module);
        }, 100)
      ).on('load', function () {
        self.scrollToModuleTop($module);
      });

      $module.nodes.$body.on('touchstart', function () {
        self.draggingInProgress = false;
      }).on('touchmove', function () {
        self.draggingInProgress = true;
      }).on('touchend', function () {
        self.draggingInProgress = false;
      });

      if (self.allSecondaryFilters.length > 0) {
        $module.nodes.$secondaryFiltersContainer.on('contentFilter.secondaryFiltersReady', function () {
          $module.nodes.$secondaryFiltersContainer.trigger('contentFilter.initSecondaryFilters', [self.allSecondaryFilters, self.attached]);
        });
        $module.nodes.$secondaryFiltersContainer.on('contentFilter.secondaryFiltersOverlay', function () {
          $module.nodes.$secondaryFiltersContainer.trigger('contentFilter.filtered', [self.results.$allFilteredElements]);
        });
        $module.nodes.$secondaryFiltersContainer.on('contentFilter.getOverlayResultsCount', function (event, primaryFilter, secondaryFilters) {
          var results = $module.nodes.$elements.filter('.js-filter--' + self.sanitizedFilter(primaryFilter.toLowerCase()));
          if (secondaryFilters) {
            results = results.filter(secondaryFilters.replace(/,/g, ''));
          }
          return results;
        });
      }

      $module.nodes.$primaryFilterBtn.once().on('click touchend keydown', function (event) {
        var $selectedFilterButton = $(this);
        var $filteredResults = [];

        if ((self.isMobileLayout && self.draggingInProgress) || !self.clickOrEnter(event)) {
          return;
        }
        self.activateFilterUI($selectedFilterButton);
        if ($selectedFilterButton.closest(self.selectors.filters).length > 0) {
          self.activateFilter($module, $selectedFilterButton.text().trim());
          if (self.allSecondaryFilters.length > 0) {
            $(document).trigger('contentFilter.initSecondaryFilters', [self.allSecondaryFilters, self.attached]);
          }
        } else {
          $filteredResults = $module.nodes.$elements.filter('.js-filter--' + self.sanitizedFilter($selectedFilterButton.attr('aria-label').toLowerCase()));
          $(document).trigger('contentFilter.filtered', [$filteredResults, true]);
        }
      });

      $module.nodes.$sortSelect.on('open', function () {
        $module.nodes.$controlsContainer[0].scrollIntoView();
        $module.nodes.$html.addClass('content-filter-set-formatter__overlay');
        $(self.selectors.sortDropdownMenu).css({ top: $module.offset().top });
      }).on('close', function () {
        $module.nodes.$html.removeClass('content-filter-set-formatter__overlay');
        self.queryParams.sort = $(this).val();
        self.queryParams.currentPage = 1;
        self.updateURL($module);
        self.scrollToModuleTop($module);
      });

      $(document).on('contentFilter.secondaryFilter', function (event, secondaryFilters, primaryFilter = '') {
        var $selectedFilterButton = $();
        self.queryParams.currentPage = 1;
        if (primaryFilter) {
          $selectedFilterButton = $module.nodes.$primaryFilterBtn.filter('[aria-label="' + primaryFilter + '"]');
          self.activateFilterUI($selectedFilterButton);
          self.queryParams.filter = primaryFilter;
          self.scrollToModuleTop($module);
        }
        if (secondaryFilters.length > 0) {
          self.queryParams.secondaryFilterSelector = secondaryFilters;
        } else {
          self.queryParams.secondaryFilterSelector = false;
        }
        self.updateURL($module);
        self.render($module, self.queryParams.secondaryFilterSelector === false);
      });
    },
    clickOrEnter: function (event) {
      return event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter');
    },
    getURLParameter: function (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    },
    parseAndRenderURL: function ($module) {
      var self = this;
      var filterParam = self.getURLParameter('section');

      if (filterParam) {
        var sortParam = self.getURLParameter('sort').replace('_', ' ');
        var $filter = self.getFilterFromUrl($module);

        if ($filter.length > 0) {
          if (sortParam) {
            $module.nodes.$sortSelect.val(sortParam);
            $module.nodes.$sortSelect.selectBox('value', sortParam);
            self.queryParams.sort = $module.nodes.$sortSelect.val();
          }
          self.activateFilterUI($filter);
          self.activateFilter($module, $filter.text().trim());
          self.render($module, true); // Force hard render so results show after URL param
        } else {
          // Invalid URL params
          self.updateURL($module);
        }
      }
    },
    // Establish the URL to redirect to based on active queryParams.
    updateURL: function ($module) {
      var self = this;
      var generatedURL = '';

      if (self.queryParams.filter) {
        generatedURL += 'section=' + self.sanitizedFilter(self.queryParams.filter);
      }
      if (self.queryParams.sort) {
        generatedURL += '&sort=' + self.queryParams.sort;
      }
      if (self.queryParams.secondaryFilterSelector) {
        generatedURL += $(document).triggerHandler('contentFilter.passSecondaryFiltersIntoUrl');
      }
      if (generatedURL) {
        self.render($module, true);
        history.replaceState(null, null, '?' + generatedURL);
      }
    },
    getFilterFromUrl: function ($module) {
      var self = this;

      // Loop through all the button filters and match them to the URL params.
      // CSS4 supports case insensitive selectors for attributes, CSS3 doesn't.
      // We loop through the few filters, get the name attribute, and check it against the filterParams.
      var filterParam = self.getURLParameter('section').replace(/_/g, ' ');
      var $found = $();

      $module.nodes.$primaryFilterBtn.each(function () {
        var $filterSetButton = $(this);
        if (!$found.length && $filterSetButton.attr('aria-label') && $filterSetButton.attr('aria-label').trim().toLowerCase() === filterParam.toLowerCase()) {
          $found = $filterSetButton;
        }
      });

      return $found;
    },
    sanitizedFilter: function (str) {
      if (Drupal.settings.ru_character_check) {
        return str.replace(/ /g, '_').trim();
      }

      return str.replace(/[^A-Z0-9]/ig, '_').trim();
    },
    // Set variables related to filter
    activateFilter: function ($module, filter) {
      var self = this;

      self.queryParams.filter = filter;
      self.queryParams.secondaryFilterSelector = false;
      self.queryParams.currentPage = 1;

      if (self.attached) {
        self.updateURL($module);
        $(document).trigger('contentFilter.secondaryFilterReset');
      }
    },
    // UI Related actions to activateFilter
    activateFilterUI: function ($filter) {
      var self = this;
      var $primaryFiltersContainer = $filter.closest(self.selectors.primaryFiltersContainer);
      var scrollPos = $filter.get(0).offsetLeft + ($filter.outerWidth(true) - $primaryFiltersContainer.outerWidth(true)) / 2;

      $primaryFiltersContainer.find('.active').removeClass('active').attr('aria-checked', 'false');
      $filter.addClass('active').attr('aria-checked', 'true');
      $primaryFiltersContainer.animate({
        scrollLeft: scrollPos
      }, 300, "linear");
    },
    animateResult: function ($element, animationTime) {
      setTimeout(function () {
        $element.addClass('result-visible');
      }, animationTime);
    },
    removeResults: function ($elements, animationTime) {
      $elements.removeClass('result-visible');
      setTimeout(function () {
        $elements.addClass('result-hidden');
      }, animationTime);
    },
    scrollToModuleTop: function ($module) {

      if ($module.data('scroll-to-module') !== true) {
        return;
      }

      var self = this;
      var $gnavHeader = $(self.selectors.gnavHeader);
      var stickyNavHeight = 0;
      var moduleTop = $module.offset().top;
      var curTop = $(window).scrollTop();

      if (moduleTop < curTop) {
        stickyNavHeight += $gnavHeader.outerHeight(true);
      }

      $module.nodes.$html.animate({
        scrollTop: moduleTop - stickyNavHeight
      }, 500, "linear");
    },
    stickyControls: function ($module) {
      var self = this;
      var headerHeight = 0;
      var processStickyHeader = true;
      var startPos = $module.offset().top;
      var currentPos = $(window).scrollTop();
      var $sortDropdownMenu = $(self.selectors.sortDropdownMenu);
      var $siteHeaderSticky = $(self.selectors.siteHeaderSticky);

      if ($module.nodes.$controlsContainer.data('isSticky')) {
        if (processStickyHeader && $module.nodes.$body.hasClass('js-sticky-header')) {
          // if the header is sticky we need to use it in the startPos check
          headerHeight = $siteHeaderSticky.outerHeight(true);
          startPos = startPos - headerHeight;
          processStickyHeader = false;
        }
        currentPos = $(window).scrollTop();
        if (currentPos >= startPos) {
          $module.nodes.$controlsContainer.addClass('sticky');
          $sortDropdownMenu.addClass('sort-sticky');
        } else {
          $module.nodes.$controlsContainer.removeClass('sticky');
          $sortDropdownMenu.removeClass('sort-sticky');
        }
      } else {
        $module.nodes.$controlsContainer.removeClass('sticky');
        $sortDropdownMenu.removeClass('sort-sticky');
      }
    },
    toggleColumnChangeClasses: function ($module) {
      var self = this;
      var size = Unison.fetch.now().name;
      var columns;
      var missingColumns;
      switch (size) {
        case 'small':
          columns = 1;
          break;
        case 'medium':
        case 'portrait':
          columns = 2;
          break;
        default:
          columns = 4;
          break;
      }
      missingColumns = (columns - self.results.$renderedResults.length % columns) % columns;
      $(self.selectors.emptyElements, $module).remove();
      while (missingColumns) {
        $module.nodes.$filterGrid.append('<div class="content-formatter__rendered result-visible js-empty-grid-item"></div>');
        missingColumns--;
      }
      self.results.$allFilteredElements.parent().removeClass('first-row first-column');
      self.results.$renderedResults.slice(0, columns).parent().addClass('first-row');
      self.results.$renderedResults.parent().filter(function( index ) {
        return index % columns === 0;
      }).addClass('first-column');
    },
    /*
    * Find all primary filter results and set $allFilteredElements.
    */
    hardRender: function ($module) {
      var self = this;
      var index = 1;
      var pendingElementsArray = [];

      self.lastSort = self.queryParams.sort;
      // Reset HTML / result collections
      $module.nodes.$filterGrid.html('');
      self.results.resultsArray = [];

      // All the results in this category
      $module.nodes.$elements.filter('.js-filter--' + self.sanitizedFilter(self.queryParams.filter.toLowerCase())).each(function () {
        // We can only reverse arrays
        self.results.resultsArray.push($(this).parent());
      });
      if (['default', 'latest-first'].includes(self.queryParams.sort)) {
        self.results.resultsArray.reverse();
      }
      // Append a cloned result
      self.results.resultsArray.forEach(function ($item) {
        var $contentFilterTout = $item.find(self.selectors.elements);
        var isFullWidthResult = $item.hasClass('js-result-full');

        $contentFilterTout.once().on('mouseover focusin', function () {
          var $hoveredTout = $(this);
          $(document).trigger('contentFilter.updateContentHeight', [$hoveredTout, true]);
        }).on('mouseout focusout', function () {
          var $hoveredTout = $(this);
          $(document).trigger('contentFilter.updateContentHeight', [$hoveredTout, false]);
        });

        if (!self.isMobileLayout) {
          $module.nodes.$filterGrid.append($item.clone(true));
        } else {
          /*
          * This block rearranges the output so that a pro tip card always takes full width.
          * We must also avoid leaving a dangling How To tout with an empty space next to it
          * because this happened.
          *
          */
          if (isFullWidthResult) {
            if (index % 2 !== 0) {
              $module.nodes.$filterGrid.append($item.clone());
            } else {
              pendingElementsArray.push($item.clone());
            }
          } else {
            $module.nodes.$filterGrid.append($item.clone());
            if (index % 2 === 0 && pendingElementsArray.length > 0) {
              $module.nodes.$filterGrid.append(pendingElementsArray.shift());
            }
            index++;
          }
        }
      });
      if (self.isMobileLayout && pendingElementsArray.length > 0) {
        $module.nodes.$filterGrid.append(pendingElementsArray);
      }
      // Save new results
      self.results.$renderedResults = self.results.$allFilteredElements = $(self.selectors.elements, $module.nodes.$filterGrid);
      self.toggleColumnChangeClasses($module);
      $module.nodes.$contentFilterTitleLabel.text(self.queryParams.filter);
      $(document).trigger('clickableBlocks.reattach', [self.results.$renderedResults]);
      $(document).trigger('videos.reattach', [self.results.$renderedResults]);
    },

    /*
    * Determine to re-render or animate results.
    */
    render: function ($module, forceHardRender) {
      var self = this;
      var $unusedToutParents = $();
      var sliceFrom = self.results.resultsPerPage * (self.queryParams.currentPage - 1);
      var sliceTo = self.results.resultsPerPage * self.queryParams.currentPage;
      var $elementsToRemove = $();
      var $elementsToSlice = $();
      var $lastChild = $();
      var $beforeLastChild = $();
      var lastSlice = false;

      if (forceHardRender) {
        self.hardRender($module);
      }
      /*
      * Filter primary filters with secondary filters.
      */
      if (self.queryParams.secondaryFilterSelector) {
        // All visible results from filter combinations
        var secondaryResult = self.queryParams.secondaryFilterSelector.replace(/,/g, '');

        self.results.$renderedResults = self.results.$allFilteredElements.filter(secondaryResult);
        if (self.results.$renderedResults.length < 1) {
          $module.nodes.$contentFormatter.addClass('result-hidden').removeClass('result-visible');
        }
      }
      $unusedToutParents = $(self.selectors.elements, $module.nodes.$filterGrid).not(self.results.$renderedResults).parent();
      $(document).trigger('contentFilter.filtered', [self.results.$allFilteredElements]);

      // Determine if any results exist
      if (self.results.$renderedResults.length > 0) {
        $module.nodes.$filterNoResults.parent().addClass('hidden');
        $module.nodes.$contentCountContainer.removeClass('hidden');
        if (self.results.$renderedResults.length > 1) {
          $module.nodes.$contentCountSingularSuffix.addClass('hidden');
          $module.nodes.$contentCountPluralSuffix.removeClass('hidden');
        } else {
          $module.nodes.$contentCountSingularSuffix.removeClass('hidden');
          $module.nodes.$contentCountPluralSuffix.addClass('hidden');
        }
        $module.nodes.$contentCountNumber.text(self.results.$renderedResults.length);
        $module.nodes.$contentCountContainer.removeClass('hidden');
      } else {
        $module.nodes.$filterNoResults.parent().removeClass('hidden');
        $module.nodes.$contentCountContainer.addClass('hidden');
      }

      /*
      * Pagination
      */
      // Show the "page" by splicing all results created
      if (sliceTo < self.results.$renderedResults.length) {
        $module.nodes.$filterMore.parent().removeClass('hidden');
      } else {
        $module.nodes.$filterMore.parent().addClass('hidden');
        lastSlice = true;
      }

      if (self.results.$renderedResults.length > 0) {
        // Change how many are shown in mobile so that nothing is as a widow.
        // If the previous item was full width, make the element after last the new last to avoid empty space in a 2 column row.
        $elementsToSlice = self.results.$renderedResults.slice(sliceFrom, sliceTo);
        if (self.isMobileLayout) {
          $lastChild = $elementsToSlice.last().parent();
          $beforeLastChild = $lastChild.prev();
          // Remove the hidden so we can measure the offset
          $elementsToSlice.parent().removeClass('result-hidden');
          if ($beforeLastChild.length > 0 && $beforeLastChild.offset().top !== $lastChild.offset().top && !$lastChild.hasClass('js-result-full') && !lastSlice) {
            sliceTo++;
          }
        }
        // count here when pro tip are displayed
        $elementsToRemove = self.results.$renderedResults.parent().slice(sliceTo);
        /*
        * Remove unfiltered results.
        */
        self.removeResults($unusedToutParents, 300);
        self.removeResults($elementsToRemove, 0);

        $elementsToSlice = self.results.$renderedResults.slice(sliceFrom, sliceTo);
        $elementsToSlice.parent().each(function (index) {
          var $elem = $(this);

          $elem.removeClass('result-hidden');
          self.animateResult($elem, index * 75);
        });
        self.toggleColumnChangeClasses($module);
      }
      $module.nodes.$filterMore.once().on('click keydown', function (event) {
        if (!self.clickOrEnter(event)) {
          return;
        }
        self.queryParams.currentPage++;
        self.render($module);
      });
    },
  };
})(jQuery);
